import { getAction, postAction } from "@/api/manage";
export default {
  name: "RefundModal",
  mixins: [],
  components: {},
  data: function data() {
    return {
      visible: false,
      orderInfo: {},
      eventApplyInfo: {},
      comment: "",
      disableRefund: true
    };
  },
  created: function created() {},
  methods: {
    refund: function refund(order) {
      this.visible = true;
      this.disableRefund = true;
      this.orderInfo = order;
      console.log(order);
      this.getEventApplyInfo(this.orderInfo.eventApplyIds);
    },
    getEventApplyInfo: function getEventApplyInfo(id) {
      var _this = this;
      getAction("/teaching/teachingEventApply/getApplyInfo?eventApplyId=" + id).then(function (res) {
        if (res.success) {
          _this.eventApplyInfo = res.result;
          if (_this.eventApplyInfo.event && _this.eventApplyInfo.event.applyConfig) {
            _this.disableRefund = !_this.eventApplyInfo.canRefund;
          }
        } else {
          _this.$message.info(res.message);
        }
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;
      if (!this.orderInfo) return;
      if (this.comment == "") {
        this.$message.info("请填写退费原因");
        return;
      }
      if (this.disableRefund) {
        this.$message.info("未开放退费");
        return;
      }
      getAction("/teaching/teachingOrder/refundApply", {
        orderNo: this.orderInfo.orderNo,
        comment: this.comment
      }).then(function (res) {
        if (res.success) {
          _this2.$message.info(res.message);
          _this2.visible = false;
          _this2.$emit("ok");
        } else {
          _this2.$message.info(res.message);
        }
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    }
  }
};